import { Component, Input } from '@angular/core';
import { Toast, ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  @Input() toast!: Toast;

  isHoveringToast: boolean = false;
  alertClass: string = '';

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.alertClass = `alert-${this.toast.status}`;
    this.toastTimer();
  }

  // get counterValue() {
  //   return `--value: ${this.toast.counter}`;
  // }

  toastTimer() {
    setTimeout(() => {
      if (this.isHoveringToast) {
        // don't decrement, but update last changed time
        this.toastService.updateLastUpdated(this.toast);
      } else if (this.toast.progressPercentage > 0) {
        this.toastService.decrementToastProgress(this.toast);
      } else if (this.toast.progressPercentage <= 0) {
        this.toastService.removeToast(this.toast);
        return;
      }
      this.toastTimer();
    });
  }

  clearToast() {
    this.toastService.removeToast(this.toast);
    this.isHoveringToast = false;
  }

  onHoverToast(ev: Event) {
    ev.stopPropagation();
    this.isHoveringToast = true;
  }

  onMouseOutToast(ev: Event) {
    ev.stopPropagation();
    this.isHoveringToast = false;
  }
}
